<template>
    <div>
        <div class="card dashcard mb-0">
            <div class="card-body">
                <div class="form-row">
                    <div class="col col-12 col-md-6">
                        <az-periodo v-model="filtro" :sync="true" @sync="load()" />
                    </div>
                    <div class="col col-12 col-md-6">
                        <az-input icon="fa fa-search fa-fw" v-model="search" />
                    </div>
                </div>
            </div>
        </div>

        <div class="progress mt-1 mb-2" v-if="lista && lista.length">
            <div class="indeterminate" v-if="$store.state.loading"></div>
            <div class="determinate" v-else></div>
        </div>    

        <az-empty-state 
            class="mt-3" 
            v-if="!lista || !lista.length"
            icon="fa fa-search"
            :action="dados === null ? 'Buscar' : ''"
            :method="load" />

        <div v-else>
            <table class="table bg-white">
                <thead>
                    <tr>
                        <th>Data/Hora</th>
                        <th>Nome</th>
                        <th>Matrícula</th>
                        <th>Login</th>
                        <th>Elegível</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(login, ilx) in lista" :key="ilx">
                        <td class="text-nowrap">
                            <span v-if="login.created_at">
                                {{ $util.getFormatDate(login.created_at) }}
                                {{ login.created_at.substr(11,5) }}
                            </span>
                        </td>
                        <td>{{ login.st_nome }}</td>
                        <td>{{ login.st_numero_carteira }}</td>
                        <td>{{ login.st_login }}</td>
                        <td>
                            <a href="#" @click.prevent="ver(login)" class="card-link h4 mb-0">
                                <i class="fa fa-check-circle text-success" v-if="login.fl_elegivel" aria-hidden="true"></i>
                                <i class="fa fa-times-circle text-danger" v-else-if="login.fl_elegivel === false" aria-hidden="true"></i>
                                <i class="fa fa-question-circle text-primary" v-else aria-hidden="true"></i>
                            </a>
                        </td>
                    </tr>
                </tbody>
            </table>

        </div>

        <!-- Modal -->
        <div class="modal fade" id="infoLoginModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Informações</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body" v-if="item">
                        <div class="alert alert-info">
                            <div v-if="item.st_nome" class="lead mb-2">
                                {{ item.st_nome }}
                            </div>
                            
                            <div v-if="item.st_numero_carteira">
                                <i class="fa fa-credit-card fa-fw mr-3" aria-hidden="true"></i>
                                {{ item.st_numero_carteira }}
                            </div>
                            <div v-if="item.st_login">
                                <i class="fa-solid fa-key fa-fw mr-3"></i>
                                {{ item.st_login }}
                                <span v-if="item.st_senha">
                                    <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                                    {{ item.st_senha }}
                                </span>
                            </div>
                            
                        </div>

                        <div v-if="item.fl_elegivel" class="alert alert-success mb-0">
                            <i class="fa fa-check-circle fa-fw mr-3" aria-hidden="true"></i>
                            Elegível

                            <div v-if="item.js_retorno && item.js_retorno.carencia" class="mt-2">
                                <hr>
                                <strong>Carência</strong>
                                <div v-for="(carencia, titulo, icx) in item.js_retorno.carencia" :key="icx">
                                    <div class="text-muted small">{{ titulo }}:</div>
                                    <div>{{ carencia }}</div>
                                </div>
                            </div>

                            <div v-if="item.js_retorno && item.js_retorno.dados_bancarios" class="mt-2">
                                <hr>
                                <strong>Dados Bancários</strong>
                                <div v-for="(dado, titulo, icx) in item.js_retorno.dados_bancarios" :key="icx">
                                    <span class="text-muted">{{ titulo }}:</span>
                                    <span class="ml-1">{{ dado }}</span>
                                </div>
                            </div>
                        </div>

                        <div v-else-if="item.fl_elegivel === null">
                            <div class="alert alert-primary mb-0">
                                Elegibilidade não verificada
                            </div>
                        </div>

                        <div v-else>
                            <div class="alert alert-danger mb-0">
                                <i class="fa fa-times-circle mr-3 fa-fw" aria-hidden="true"></i>
                                Elegibilidade inválida.

                                <div>
                                    {{ item.st_obs }}
                                </div>
                            </div>
                        </div>

                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import $ from 'jquery';
import _ from 'lodash';
import AzInput from '../../shared/forms/AzInput.vue';
import AzPeriodo from '../../shared/forms/AzPeriodo.vue';
import AzEmptyState from '../../util/AzEmptyState.vue';

export default {
    data() { 
        return { 
            search: "", 
            filtro: { 
                inicio: "",
                fim: "",
                periodo: "h",
                semana: "",
                mes: "", 
            },
            dados: null, 
            item: null, 
        }
    },

    components: { 
        AzInput,
        AzPeriodo,
        AzEmptyState, 
    },

    computed: { 
        lista: function () { 
            if ( !this.dados )
                return [];

            if ( !this.search )
                return this.dados;

            let reg = this.$util.getregex(this.search);

            return this.dados.filter(item => reg.test(JSON.stringify(item)));
        }
    }, 

    methods: { 
        load() { 
            this.$util.load(this, { 
                service: 'login_operadoras',
                func: 'index',
                parms: this.filtro, 
                loadTo: res => { 
                    this.dados = res;
                }
            });
        },

        ver(item) { 
            this.item = _.cloneDeep(item);

            $('#infoLoginModal').modal('show');
        }
    },

    mounted() { 

        // this.load();

    }
}
</script>